import React, { useEffect, useRef } from "react";
import { SpryAuthProvider, useSpryAuth } from "spry-apps-dropdown";
import { useDispatch } from "react-redux";
import oidcConfig from "../config/oidcConfig";
import { verifyAuth, setSession } from "../redux/slice/authSlice";
import { clearKeycloakTokens, persistKeycloakTokens } from "../helpers/keycloakAuth";

const AUTH_PROVIDER_KEY = "auth_provider";

const AuthSync = ({ children }) => {
  const auth = useSpryAuth();
  const dispatch = useDispatch();
  const lastVerifiedToken = useRef(null);

  useEffect(() => {
    const accessToken = auth.user?.access_token;

    if (auth.isAuthenticated && accessToken) {
      persistKeycloakTokens(auth.user);
      window.localStorage.setItem(AUTH_PROVIDER_KEY, "keycloak");

      if (lastVerifiedToken.current !== accessToken) {
        lastVerifiedToken.current = accessToken;
        const internalRole = auth.user?.state?.internalRole;
        const organizationId = auth.user?.state?.organizationId;
        // Temporary debug log to verify state propagation
        if (internalRole) {
          // eslint-disable-next-line no-console
          console.log("[Keycloak] internalRole from state:", internalRole);
        } else {
          // eslint-disable-next-line no-console
          console.log("[Keycloak] internalRole missing from state", auth.user?.state);
        }
        if (internalRole || organizationId) {
          dispatch(
            verifyAuth({
              ...(internalRole ? { internalRole } : {}),
              ...(organizationId ? { organizationId } : {}),
            })
          );
        } else {
          dispatch(verifyAuth());
        }
      }
    }
  }, [auth.isAuthenticated, auth.user?.access_token, dispatch]);

  useEffect(() => {
    if (!auth.isLoading && !auth.isAuthenticated) {
      const authProvider = window.localStorage.getItem(AUTH_PROVIDER_KEY);
      if (authProvider !== "keycloak") {
        return;
      }
      lastVerifiedToken.current = null;
      clearKeycloakTokens();
      window.localStorage.removeItem(AUTH_PROVIDER_KEY);
      dispatch(setSession({ user: null, status: "unauthorized", error: null }));
    }
  }, [auth.isLoading, auth.isAuthenticated, dispatch]);

  return children;
};

const KeycloakProvider = ({ children }) => {
  return (
    <SpryAuthProvider config={oidcConfig}>
      <AuthSync>{children}</AuthSync>
    </SpryAuthProvider>
  );
};

export default KeycloakProvider;
